

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Chip from '@material-ui/core/Chip';
import ClassName from  "./Experience.module.css"

const styles = theme => ({
  heading: {
    fontSize: '1.1em',
    flexBasis: '60%',
    flexShrink: 0,
    paddingRight:'5px' 
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color:'#fff',
  },
  expB:{
    color:'#fff',
    backgroundColor: '#107482'
  },
  details:{
    color:'#fff',
    backgroundColor: '#004953',
    },
    chip: {
      margin: theme.spacing.unit,
      backgroundColor:'White'
    },
    ic:{
      color:'#fff'
    }
});

class Experience extends React.Component {
  state = {
    expanded: null,
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    const { classes } = this.props;
    const { expanded } = this.state;

    return (
      <div className={ClassName.Hi}>
         <span className={ClassName.experience_heading}>Experience</span>
         <div className={ClassName.exp_block}>
        <ExpansionPanel className={classes.expB} expanded={expanded === 'panel1'} onChange={this.handleChange('panel1')}>
          <ExpansionPanelSummary className={classes.expB1} expandIcon={<ExpandMoreIcon className={classes.ic}/>}>
            <Typography className={classes.heading}>Robo MQ Pvt. Ltd.</Typography>
            <Typography className={classes.secondaryHeading}>Jan 2022-Present</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.details}>
            <Typography>
            It is a product-based start-up company where I work as an Associate Software Engineer. I have worked on multiple features of the products in this company, from design to development.
            <div>
            <Chip label="Angular JS" className={classes.chip} variant="outlined" />
            <Chip label="Node JS" className={classes.chip} variant="outlined" />
            <Chip label="Express Js" className={classes.chip} variant="outlined" />
            <Chip label="SQL" className={classes.chip} variant="outlined" />
            <Chip label="Type Script" className={classes.chip} variant="outlined" />
            <Chip label="HTML" className={classes.chip} variant="outlined" />
            <Chip label="CSS" className={classes.chip} variant="outlined" />

            </div>
            </Typography>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel className={classes.expB} expanded={expanded === 'panel2'} onChange={this.handleChange('panel2')}>
          <ExpansionPanelSummary  expandIcon={<ExpandMoreIcon className={classes.ic}/>}>
            <Typography className={classes.heading}>Kistechnosoftware Pvt. Ltd.</Typography>
            <Typography className={classes.secondaryHeading}>
            Aug 2021-Nov 2021
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.details}>
            <Typography>
            I worked on an Admin panel with the team where I was working on part of the UI.
            <div>
            <Chip label="React JS" className={classes.chip} variant="outlined" />
            <Chip label="Node JS" className={classes.chip} variant="outlined" />
            <Chip label="Express Js" className={classes.chip} variant="outlined" />
            <Chip label="Mongo DB" className={classes.chip} variant="outlined" />
            </div>
            </Typography>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel className={classes.expB} expanded={expanded === 'panel3'} onChange={this.handleChange('panel3')}>
          <ExpansionPanelSummary  expandIcon={<ExpandMoreIcon className={classes.ic}/>}>
            <Typography className={classes.heading}>Celebal Technologies Pvt. Ltd.</Typography>
            <Typography className={classes.secondaryHeading}>
            May 2021 - July 2021
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.details}>
            <Typography>
            It was a project-based internship In which I developed a Poll
            Counter Application for users in which they can give their
            opinion freely and can see others' opinions also.
            <div>
            <Chip label="React JS" className={classes.chip} variant="outlined" />
            <Chip label="Node JS" className={classes.chip} variant="outlined" />
            <Chip label="Express Js" className={classes.chip} variant="outlined" />
            <Chip label="Mongo DB" className={classes.chip} variant="outlined" />
            </div>
            </Typography>
            
          </ExpansionPanelDetails>
        </ExpansionPanel>
        </div>
      </div>
    );
  }
}

Experience.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Experience);
